import { useInfiniteQuery, useMutation } from '@tanstack/react-query'

import { messageApi } from '../api/messageApi'
import { MESSAGE_TYPE } from '../models/Message.enums'
import { getConversationMessagesOptions } from './useConversationMessagesQuery'

export const useCreateTextMessageMutation = ({ conversationId }: { conversationId: number }) => {
  const { fetchNextPage } = useInfiniteQuery(getConversationMessagesOptions(conversationId))
  return useMutation({
    mutationFn: (text: string) =>
      messageApi.createMessage({ type: MESSAGE_TYPE.TEXT, conversationId, payload: { text } }),
    onSuccess: () => fetchNextPage(),
  })
}
